import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import {
  Button,
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Spinner,
} from "react-bootstrap";

//
import {
  changePlanModalStep,
  setPlanDiscount,
} from "../../../redux/features/plan/slice";
import { checkDisacountCode } from "../../../redux/features/plan/actions";

//
import Ribbon from "../../general/Ribbon";

function Invoice({ choosedPlan, changePlanModalStep, setPlanDiscount }) {
  const [limit, setLimit] = useState(2);

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  /**
   * Check Discount Code
   */
  const checkCode = async (e) => {
    e.preventDefault();

    // start loading
    setLoading(true);

    // set variable
    let content = {
      coupon: code,
      product_id: choosedPlan.id,
    };

    // request
    await checkDisacountCode(content).then((res) => {
      if (res) {
        let discountCode = code;
        let prices = res;

        setPlanDiscount({ discountCode, prices });
      }
    });

    // stop loading
    setLoading(false);
  };
  return (
    <>
      <Row className="plans">
        <Col xs={12} className="overflow-hidden">
          <Card className="item bordered">
            {choosedPlan.isBest && (
              <Ribbon
                variant="warning"
                size="thine"
                content="Best Plan 🔥 . Best Plan 🔥 . Best Plan 🔥"
              />
            )}
            <Card.Body>
              <div className="name">
                <h5>{choosedPlan.name}</h5>
                <img src={choosedPlan.image} alt="plan icon" />
              </div>

              <div className="price">
                {+choosedPlan.price_usd ? (
                  <>
                    <h3
                      className="fw-bolder"
                      style={{
                        textDecoration: choosedPlan.discountCode
                          ? "line-through"
                          : "",
                      }}
                    >
                      ${choosedPlan.price_usd}
                    </h3>
                    {choosedPlan.price_point && (
                      <span
                        className="text-warning"
                        style={{
                          textDecoration: choosedPlan.discountCode
                            ? "line-through"
                            : "",
                        }}
                      >
                        or {choosedPlan.price_point} Points
                      </span>
                    )}
                  </>
                ) : (
                  <h3 className="fw-bolder">Free</h3>
                )}
              </div>

              {/* just show when discount code is valid */}
              {choosedPlan.discountCode && (
                <div className="price mt-0">
                  <h3 className="fw-bolder">
                    {choosedPlan.discountPrice.USD.priceWithDiscount}
                  </h3>
                  {choosedPlan.discountPrice.POINT && (
                    <span className="text-warning">
                      / {choosedPlan.discountPrice.POINT.priceWithDiscount}{" "}
                      coins
                    </span>
                  )}
                </div>
              )}

              <p className="decription">{choosedPlan.description}</p>

              <div className="permissions">
                {Object.keys(choosedPlan.features)
                  .slice(0, limit)
                  .map((keyName, i) => (
                    <p key={i}>
                      <i
                        className={`las la-${
                          choosedPlan.features[keyName].active
                            ? "check success"
                            : "times danger"
                        }`}
                      ></i>
                      <span>{choosedPlan.features[keyName].title}</span>
                    </p>
                  ))}
              </div>

              {limit !== Object.keys(choosedPlan.features).length && (
                <p
                  className="text-info learn-more"
                  onClick={() =>
                    setLimit(Object.keys(choosedPlan.features).length)
                  }
                >
                  Learn more
                </p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {!!+choosedPlan.price_usd && (
        <Form onSubmit={checkCode}>
          <InputGroup>
            <Form.Group className="form-group mb-0">
              <Form.Control
                type="text"
                placeholder="Discount code"
                className="form-control"
                autoComplete="off"
                onChange={(e) => setCode(e.target.value)}
                value={code}
              />
            </Form.Group>
            <InputGroup.Text>
              <Button
                variant="info"
                className="h-100"
                type="submit"
                disabled={!code}
              >
                Check Code
                {loading && (
                  <div className="spinner-holder">
                    <Spinner animation="border" variant="white" size="sm" />
                  </div>
                )}
              </Button>
            </InputGroup.Text>
          </InputGroup>
        </Form>
      )}

      <div className="actions ">
        <div
          className="back"
          onClick={() => changePlanModalStep("choose-plan")}
        >
          Back
        </div>

        <Button
          variant="info"
          size="lg"
          onClick={() => changePlanModalStep("choose-method")}
        >
          Continue
        </Button>
      </div>
    </>
  );
}

Invoice.propTypes = {
  choosedPlan: PropTypes.object.isRequired,
  changePlanModalStep: PropTypes.func.isRequired,
  setPlanDiscount: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  changePlanModalStep,
  setPlanDiscount,
};

const mapStateToProps = (state) => ({
  choosedPlan: state.planReducer.choosedPlan,
});

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
